import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=224fa2ac&"
import script from "./faq.vue?vue&type=script&lang=js&"
export * from "./faq.vue?vue&type=script&lang=js&"
import style0 from "./faq.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('224fa2ac')) {
      api.createRecord('224fa2ac', component.options)
    } else {
      api.reload('224fa2ac', component.options)
    }
    module.hot.accept("./faq.vue?vue&type=template&id=224fa2ac&", function () {
      api.rerender('224fa2ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/pages/info/faq.vue"
export default component.exports